// @ts-nocheck
import PropTypes from "prop-types";
import React from "react";

import AnchorLink from "../anchorLink";

import styles from "./styles.css";

function Column({ items, label }) {
    return (
        <nav className={styles.nav}>
            <h3 className={styles.navTitle}>{label}</h3>
            <ul className={styles.navList}>
                {items.map(({ label, path }) => {
                    return (
                        <li className={styles.navItem} key={label}>
                            <AnchorLink className={styles.navItemLink} href={path}>
                                {label}
                            </AnchorLink>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}

Column.propTypes = {
    items: PropTypes.array.isRequired,
    label: PropTypes.string.isRequired,
};

export default function Footer({ items }) {
    return (
        <div className={styles.footer}>
            <div className={styles.container}>
                {items.map(({ label, items }) => {
                    return <Column items={items} label={label} key={label} />;
                })}
            </div>
        </div>
    );
}

Footer.propTypes = {
    items: PropTypes.array,
};
